const numUnit = ["", "k", "m", "g", "t"];

/**
 * 格式化数字为大数
 * @param num 数字
 */
function formatNumber(num: number, count: number = 0): string {
  if (num.toString().indexOf("B") < 0) {
    const ret = Number((num / 1000).toFixed(1));
    return ret > 1 ? formatNumber(ret, ++count) : (num || "0") + numUnit[count];
  }
  return String(num);
}

/**
 * 格式化数字为k
 * @param num 数字
 */
function formatNumberK(num: number) {
  return num > 1000 ? `${(num / 1000).toFixed(2)}k` : num;
}

/**
 * 格式化数字为万
 * @param num 数字
 * @param fixed 保留几位小数
 */
function formatNumberW(num: number, fixed: number = 1) {
  return num > 10000 ? `${(num / 10000).toFixed(fixed)}万` : num;
}

export { formatNumber, formatNumberK, formatNumberW };
